<template>
  <div class="container">
    <div v-if="!show_help" class="personal-container">
      <h4 class="name">{{ name }}</h4>
      <mt-button type="default" class="btn" @click="changeAccount"
        >切换账号</mt-button
      >
      <mt-button type="default" class="help" @click.native="showHelp"
        >帮助</mt-button
      >
    </div>
    <div v-else class="faq-container">
      <div class="nav">
        <mt-button
          size="small"
          @click.native.prevent="active = '552'"
          :class="active === '552' ? 'active' : ''"
          >552</mt-button
        >
        <mt-button
          size="small"
          @click.native.prevent="active = '4180'"
          :class="active === '4180' ? 'active' : ''"
          >4180</mt-button
        >
        <mt-button
          size="small"
          @click.native.prevent="active = '5590'"
          :class="active === '5590' ? 'active' : ''"
          >5590</mt-button
        >
      </div>
      <div class="page-tab-container">
        <mt-tab-container
          class="page-tabbar-tab-container"
          v-model="active"
          swipeable
        >
          <mt-tab-container-item id="552">
            <div v-for="n in faq[552]" class="question-box">
              <h4>{{ n.question }}</h4>
              <div v-for="asr in n.answer">
                <p>{{ asr }}</p>
              </div>
            </div>
          </mt-tab-container-item>
          <mt-tab-container-item id="4180">
            <div v-for="n in faq[4180]" class="question-box">
              <h4>{{ n.question }}</h4>
              <div v-for="asr in n.answer">
                <p>{{ asr }}</p>
              </div>
            </div>
          </mt-tab-container-item>
          <mt-tab-container-item id="5590">
            <div v-for="n in faq[5590]" class="question-box">
              <h4>{{ n.question }}</h4>
              <div v-for="asr in n.answer">
                <p>{{ asr }}</p>
              </div>
            </div>
          </mt-tab-container-item>
        </mt-tab-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { MessageBox } from "mint-ui";

import faq from "./faq.json";
export default {
  name: "Me",
  data() {
    return {
      content: "personal",
      active: "4180",
      faq
    };
  },
  methods: {
    ...mapMutations({
        clearUser: 'user/clearUser',
        changeTab: 'tab/changeTab',
        changeHelp: 'tab/changeHelp'
    }),
    showHelp() {
      this.changeTab("个人中心");
      this.changeHelp(true);
    },
    changeAccount() {
      MessageBox.confirm("你确定要退出么?", "提示")
        .then(action => {
          this.clearUser();
          this.$router.push("/operation/login");
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.userInfo,
      show_help: state => state.tab.show_help
    }),
    name: function() {
      return this.user ? this.user.tel : "易可印运维";
    }
  }
};
</script>

<style scoped lang="less">
.container {
  .personal-container {
    display: flex;
    flex-direction: column;
    .name,
    .btn,
    .help {
      margin: 10vh auto;
    }
  }
  .faq-container {
    padding-bottom: 60px;
    .active {
      color: #fff;
      background: #111;
    }
    .question-box {
      text-align: left;
      padding: 0 16px;
      h4 {
        text-decoration: underline;
        padding: 6px 0;
      }
      p {
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/children/Me/index.vue